<div id="menu" class="mt-5" data-scroll>
    <div class="container">
    <div class="row">
        <div class="col-md-5 news">
            <div class="row">
                <div class="col-12">
                    <h2 class="font-weight-bold">Latest News</h2>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-12">
                    <div class="card p-1">
                        <div class="card-body d-flex justify-content-center align-items-center">
                            <p class="lead text-justify">
                                <marquee behavior="scroll" direction="up"  onmouseover="this.stop();" onmouseout="this.start();" class="bulletinMarque pt-4">
                                    <div class="row px-lg-2">
                                        <div class="col-12" *ngFor="let item of news;let i=index">
                                            <strong><i class="fas fa-circle"></i> {{item.title}}</strong>
                                            <p [innerHtml]="item.description"></p>
                                            <a href="{{item.imgUrl}}" *ngIf="item.imgUrl!='#'">Download</a>
                                        </div>
                                        <!-- <div class="col-12">
                                            <strong><i class="fas fa-circle"></i> Admission open from Pre Nursery to 12th</strong>
                                            <p class="text-justify">इस्माईलाबाद स्थित स्प्रिंगडेल पब्लिक स्कूल में कोरोना महामारी के संकट के समय में सत्र के सफलतापूर्वक समाप्ति के लिए तथा आगामी शैक्षणिक सत्र के शुभारंभ के उपलक्ष्य में विद्यालय के प्रांगण में हवन यज्ञ का आयोजन किया गया| जिसके माध्यम से वर्तमान शैक्षणिक स्तर के सफलतापूर्वक समाप्ति के लिए ईश्वर से प्रार्थना की गई। तथा आगामी सत्र के शुभारंभ के लिए बच्चों के सर्वागीण विकास में उनकी उत्तम सफलता के लिए मंगल कामना की|...</p>
                                        </div> -->
                                    </div>
                                   </marquee>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-7">
            <div class="">
                <div class="box box1" routerLink="/admission/process">
                    <i class="fas fa-user-graduate"></i>
                    <h4 class="font-weight-bold">MPPS</h4>
                    <h4><strong>Admission</strong></h4>
                </div>
                			
                <div class="box box3 clearfix" routerLink="/accomplishment/cultural">
                    <i class="fa fa-black-tie" aria-hidden="true"></i>
                    <h4 class="font-weight-bold">MPPS</h4>
                    <h4><strong>Cultural</strong></h4>
                </div>
                <div class="box box2" routerLink="/accomplishment/games">
                    <i class="fas fa-running"></i>
                    <h4 class="font-weight-bold">MPPS</h4>
                    <h4><strong>Sports</strong></h4>
                </div>
                <div class="box box1 clearfix" routerLink="/achievements/awards">
                    <i class="fas fa-award"></i>
                    <h4 class="font-weight-bold">MPPS</h4>
                    <h4><strong>Awards</strong></h4>
                </div>
                <div class="box box3" routerLink="/achievements/cbse">
                    <i class="fas fa-poll"></i>
                    <h4 class="font-weight-bold">MPPS</h4>
                    <h4><strong>Results</strong></h4>
                </div>
                <div class="box box1">
                    <a href="https://www.facebook.com/profile.php?id=100063570684714" target="_blank">
                    <i class="fas fa-users"></i>
                    
                    <h4 class="font-weight-bold">MPPS</h4>
                    <h4><strong>Social</strong></h4>
                    </a>
                </div>
                <div class="box box3 clearfix" routerLink="/campus/infrastructure">
                    <i class="fas fa-university"></i>
                    <h4 class="font-weight-bold">MPPS</h4>
                    <h5><strong>Infrastructure</strong></h5>
                </div>
                <div class="box box2" >
                    <a href="https://www.youtube.com/watch?v=x-rsF1M0kvs&t=1s" target="_blank">
                    <i class="fab fa-hire-a-helper"></i>
                    <!-- <i class="fa fa-graduation-cap" aria-hidden="true"></i> -->
                    <h4 class="font-weight-bold">MPPS</h4>
                    <h4><strong>Help</strong></h4>
                </a>
                </div>		
                <div class="box box3" routerLink="/about-us/vision">
                    <i class="fas fa-bullseye"></i>
                    <h4 class="font-weight-bold">MPPS</h4>
                    <h4><strong>Vision</strong></h4>
                </div>
                <div class="box box2" routerLink="/glimpses/magazine">
                    <i class="far fa-newspaper"></i>
                    <h4 class="font-weight-bold">MPPS</h4>
                    <h4><strong>Magazines</strong></h4>
                </div>
            </div>
        </div>
    </div>
</div>
</div>